var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "news-detail-page" }, [
    _c("div", { staticClass: "row-d1" }, [
      _c("div", { staticClass: "wp" }, [
        _c("div", { staticClass: "col-l" }, [
          _c("div", { staticClass: "m-details" }, [
            _c("h1", [
              _vm._v(_vm._s(_vm.article.title || _vm.article.newNameCn)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("span", [
                _vm._v(
                  "发布时间：" +
                    _vm._s(_vm.article.createTime || _vm.article.newCreateTime)
                ),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "来源：" + _vm._s(_vm.article.source || _vm.article.newSource)
                ),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "浏览量：" +
                    _vm._s(_vm.article.views || _vm.article.newViews || "0")
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "txt",
              domProps: {
                innerHTML: _vm._s(
                  _vm.article.content || _vm.article.newContentCn
                ),
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "arrow" }, [
              _c(
                "div",
                {
                  staticClass: "item prev",
                  class: { disabled: !_vm.previousArticle },
                },
                [
                  _vm.previousArticle
                    ? _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0);" },
                          on: { click: _vm.goToPreviousArticle },
                        },
                        [
                          _vm._v(
                            "\n                上一篇：\n                "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.previousArticle.title ||
                                  _vm.previousArticle.newNameCn
                              )
                            ),
                          ]),
                        ]
                      )
                    : _c("span", { staticClass: "disabled-text" }, [
                        _vm._v("上一篇："),
                        _c("span", [_vm._v("没有了！")]),
                      ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "item next",
                  class: { disabled: !_vm.nextArticle },
                },
                [
                  _vm.nextArticle
                    ? _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0);" },
                          on: { click: _vm.goToNextArticle },
                        },
                        [
                          _vm._v(
                            "\n                下一篇：\n                "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.nextArticle.title ||
                                  _vm.nextArticle.newNameCn
                              )
                            ),
                          ]),
                        ]
                      )
                    : _c("span", { staticClass: "disabled-text" }, [
                        _vm._v("下一篇："),
                        _c("span", [_vm._v("没有了！")]),
                      ]),
                ]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-r" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "m-list9" },
            _vm._l(_vm.recommendedArticles, function (rec) {
              return _c("li", { key: rec.id || rec.newId }, [
                _c(
                  "a",
                  {
                    staticClass: "con",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function ($event) {
                        return _vm.goToRecommendedArticle(rec)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "date" }, [
                      _vm._v(_vm._s(rec.createTime || rec.newCreateTime)),
                    ]),
                    _vm._v(" "),
                    _c("h3", { staticClass: "tit" }, [
                      _vm._v(_vm._s(rec.title || rec.newNameCn)),
                    ]),
                  ]
                ),
              ])
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "m-t2" }, [_c("h3", [_vm._v("推荐新闻")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }